<mat-progress-bar
  color="primary"
  mode="indeterminate"
  *ngIf="_progressBar?._visible | async"
></mat-progress-bar>
